import { useState } from "react";
import { useNavigate } from "react-router-dom";
import adminApi from "../api/adminApi";
import { useAuth } from "../auth/AuthContext";
import { toast } from "react-toastify";

export default function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    try {
     
    console.log("[FRONTEND] Admin login request:", email);

      const res = await adminApi.post(
        "user/admin-login",
        { email, password },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      console.log("[FRONTEND] Admin login response:", res.data);

      const { token, user } = res.data;

      // ✅ Store admin token separately
      localStorage.setItem("adminToken", token);

      // Optional: store admin user
      localStorage.setItem("adminUser", JSON.stringify(user));

      login(res.data);

      toast.success(`Welcome ${user.name}`);

      navigate("/dashboard"); // admin dashboard
    } catch (err) {
      console.error("[FRONTEND] Admin login error:", err.response || err);
      toast.error(err.response?.data?.message || "Login failed");
    }

   
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <form onSubmit={submit} className="bg-white p-8 rounded shadow w-96">
        <h2 className="text-2xl font-bold mb-6">Admin Login</h2>
        <input className="input" placeholder="Email" onChange={(e)=>setEmail(e.target.value)} />
        <input className="input mt-3" type="password" placeholder="Password" onChange={(e)=>setPassword(e.target.value)} />
        <button className="mt-6 w-full bg-blue-600 text-white py-2 rounded">
          Login
        </button>
      </form>
    </div>
  );
}
